var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},_vm._l((_vm.blockName),function(item,index){return _c('span',{key:index,class:['name', {'active': item.isActive}],attrs:{"title":item.name},on:{"click":function($event){_vm.changeStrategy(index)}}},[_vm._v(_vm._s(item.name))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-4e202c8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/edit-plan-sub/block.vue
// module id = null
// module chunks = 